var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisCrossRemoveIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_193512)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 15C4.634 15 1.5 11.865 1.5 8C1.5 4.135 4.634 1 8.5 1C12.366 1 15.5 4.135 15.5 8C15.5 11.865 12.366 15 8.5 15ZM8.5 0C4.0815 0 0.5 3.58 0.5 8C0.5 12.42 4.0815 16 8.5 16C12.9185 16 16.5 12.42 16.5 8C16.5 3.58 12.9185 0 8.5 0ZM11.3585 5.14001C11.1615 4.94501 10.843 4.94501 10.646 5.14001L8.49701 7.28998L6.379 5.16998C6.1835 4.97498 5.8665 4.97498 5.672 5.16998C5.4765 5.36498 5.4765 5.685 5.672 5.88L7.79001 7.995L5.65701 10.13C5.46051 10.325 5.46051 10.645 5.65701 10.845C5.85401 11.04 6.173 11.04 6.37 10.845L8.50299 8.71002L10.621 10.83C10.8165 11.025 11.1335 11.025 11.3285 10.83C11.524 10.635 11.524 10.315 11.3285 10.12L9.20999 8.005L11.3585 5.85498C11.555 5.65498 11.555 5.34001 11.3585 5.14001Z",
    fill: "#E35F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_193512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisCrossRemoveIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS_Cross_Remove_Icon.62e90c9d.svg";
export { ForwardRef as ReactComponent };